import { Focusable, Tooltip } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

interface TimeProps {
  timestamp: string;
  className?: string;
}

const Time: React.FC<TimeProps> = ({ timestamp, className }) => {
  const date = new Date(timestamp);
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const fullTime = date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <Tooltip.Root delay={100} closeDelay={50}>
      <Focusable>
        <p className={cn('text-variant-caption1 font-serif', className)}>
          {formattedTime}
        </p>
      </Focusable>
      <Tooltip.Content
        placement="bottom"
        className="text-variant-caption1! p-1.5!"
      >
        {fullTime}
      </Tooltip.Content>
    </Tooltip.Root>
  );
};

export default Time;
